<script lang="ts">
	import CookieReport from "@components/CookieReport.svelte";
	import HugeHeading from "@components/HugeHeading.svelte";
	import Formatted from "@components/common/Formatted.svelte";
	import Layout from "@components/layout/Layout.svelte";
	import { formatPhoneNumber } from "@core/utils/formatPhoneNumber.js";
	import { companyAddressLines } from "../contacts/companyAddress.js";
	import { companyIco } from "../contacts/companyIco.js";
	import { companyPhone } from "../contacts/companyPhone.js";
</script>

<Layout>
	<HugeHeading
		text="Bezpečnost nl[[]] stroke[[a ochrana osobních údajů]]"
		class="full-width text-center mb-20 mild"
		level={1}
	/>
	<section class="container-8 pb-8 md:pb-16 lg:pb-20 px-2 md:px-8 font-medium">
		<HugeHeading level={2} class="xs:!text-7xl mb-3 mild" text="Totožnost a kontaktní údaje správce" />
		<table class="max-w-[35rem] mt-1">
			<tbody>
				<tr class="bg-white text-sm">
					<td class="border-gray border p-3"><Formatted text="Firma: " /></td>
					<td class="border-gray border p-3"><Formatted text="Commarec s.r.o." /></td>
				</tr>
				<tr class="bg-gray-50 text-sm">
					<td class="border-gray border p-3"><Formatted text="Sídlo: " /></td>
					<td class="border-gray border p-3"><Formatted text={companyAddressLines.join(", ")} /></td>
				</tr>
				<tr class="bg-white text-sm">
					<td class="border-gray border p-3"><Formatted text="IČ: " /></td>
					<td class="border-gray border p-3"><Formatted text={companyIco} /></td>
				</tr>
				<tr class="bg-gray-50 text-sm">
					<td class="border-gray border p-3"><Formatted text="Telefon: " /></td>
					<td class="border-gray border p-3"
						><a href="tel:{companyPhone}"><Formatted text={formatPhoneNumber(companyPhone)} /></a></td
					>
				</tr>
				<tr class="bg-white text-sm">
					<td class="border-gray border p-3"><Formatted text="E-mail: " /></td>
					<td class="border-gray border p-3"><Formatted text="info@commarec.cz" /></td>
				</tr>
			</tbody>
		</table>
		<HugeHeading level={2} class="xs:!text-7xl mb-3 mild mt-8" text="Jaké typy osobních údajů shromažďujeme?" />
		<p>
			<Formatted
				text="Shromažďujeme pouze osobní údaje, které nám poskytnete za účelem komunikace nebo zodpovězení vašeho dotazu. Tyto údaje mohou zahrnovat:"
			/>
		</p>
		<ul class="mb-3 ml-5 mt-1 list-outside [list-style-type:'–_'] marker:text-cmcprimary">
			<li><Formatted text="Jméno a přijmení" /></li>
			<li><Formatted text="Název firmy" /></li>
			<li><Formatted text="Adresu" /></li>
			<li><Formatted text="Telefonní číslo" /></li>
			<li><Formatted text="Obsah vašeho dotazu" /></li>
		</ul>
		<HugeHeading level={2} class="xs:!text-7xl mb-3 mild mt-8" text="Za jakým účelem zpracováváme osobní údaje?" />
		<p>
			<Formatted text="Osobní údaje zpracováváme výhradně za účelem:" />
		</p>
		<ul class="mb-3 ml-5 mt-1 list-outside [list-style-type:'–_'] marker:text-cmcprimary">
			<li><Formatted text="Komunikace s vámi na základě vašeho dotazu" /></li>
			<li><Formatted text="Poskytování požadovaných informací nebo služeb" /></li>
			<li><Formatted text="Zajištění odpovědí na vaše dotazy" /></li>
			<li><Formatted text="Informace o novinkách" /></li>
		</ul>
		<HugeHeading level={2} class="xs:!text-7xl mb-3 mild mt-8" text="Sdílení osobních údajů s třetími stranami" />
		<p>
			<Formatted
				text="Vaše osobní údaje nesdílíme s žádnými třetími stranami, kromě situací, kdy je to nezbytné k vyřízení vašeho dotazu nebo vyplývá ze zákonné povinnosti."
			/>
		</p>

		<CookieReport />

		<HugeHeading level={2} class="xs:!text-7xl mb-3 mild mt-8" text="Jak využíváme Cookies" />
		<p>
			<Formatted
				text="Na našem webu používáme pouze technické cookies nezbytné pro správné fungování webových stránek. Pokud bychom využívali analytické nebo marketingové cookies, budete mít možnost udělit souhlas prostřednictvím funkce opt-in."
			/>
		</p>

		<HugeHeading
			level={2}
			class="xs:!text-7xl mb-3 mild mt-8"
			text="Bezpečnostní opatření při uchovávání osobních údajů"
		/>
		<p>
			<Formatted text="Pro ochranu vašich osobních údajů jsme zavedli následující opatření:" />
		</p>
		<ul class="mb-3 ml-5 mt-1 list-outside [list-style-type:'–_'] marker:text-cmcprimary">
			<li><Formatted text="Přístup k údajům je omezen pouze na pověřené osoby" /></li>
			<li><Formatted text="Data jsou uchovávána na zabezpečených serverech" /></li>
			<li><Formatted text="Používáme šifrování pro přenos citlivých údajů" /></li>
		</ul>

		<HugeHeading level={2} class="xs:!text-7xl mb-3 mild mt-8" text="Jak můžete kontrolovat své osobní údaje?" />
		<p>
			<Formatted
				text="Pokud chcete ověřit, jaké údaje o vás zpracováváme, případně požadovat jejich opravu nebo odstranění, kontaktujte nás prostřednictvím e-mailu uvedeného na této stránce."
			/>
		</p>
		<HugeHeading level={2} class="xs:!text-7xl mb-3 mild mt-8" text="Obecná ustanovení" />
		<p>
			<Formatted
				text="Vaše osobní údaje zpracováváme v souladu se zákonem č. 110/2019 Sb., o zpracování osobních údajů, a v souladu s nařízením GDPR. Máte právo obrátit se se svými dotazy nebo stížnostmi na l[https://uoou.gov.cz/pravni-ramec/ochrana-osobnich-udaju][[Úřad pro ochranu osobních údajů]]."
			/>
		</p>
	</section>
</Layout>
